/* eslint-disable max-len */
import React from 'react';
function ElmoSurvey() {
    return (React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.99 4C21.99 2.9 21.1 2 20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H18L22 22L21.99 4ZM20 4V17.17L18.83 16H4V4H20ZM18 12H6V14H18V12ZM6 9H18V11H6V9ZM18 6H6V8H18V6Z" })));
}
export default ElmoSurvey;
